import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { HhsgSharedUserProfile } from '../models/user-profile.model';
import { Observable, ReplaySubject } from 'rxjs';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class HhsgSharedUserService implements OnDestroy, OnInit {
  private userProfile = new ReplaySubject<HhsgSharedUserProfile>(1);
  private storageKey = 'hsgUserProfile';
  public convertChildApplicationUserToHapUser: boolean = false;
  public childApplicationUser: User;

  constructor() {
    const userJson = JSON.parse(sessionStorage.getItem(this.storageKey));
    if (userJson) {
      const user: HhsgSharedUserProfile = new HhsgSharedUserProfile(userJson);
      this.userProfile.next(user);
    }
  }

  /**
   * Check session storage for user information on Init
   */
  ngOnInit() {
    
  }

  /**
   * Removes `HhsgUserProfile` from session storage and completes stream
   */
  ngOnDestroy() {
    sessionStorage.removeItem(this.storageKey);
    this.userProfile.complete();
  }

  /**
   * Accepts a `HhsgUserProfile` and sets in session storage,
   * as well as emitting the value to subscribers of `getUserProfile()`.
   * @param user `HhsgUserProfile` data that you want to set for the application
   */
  setUserProfile(user: HhsgSharedUserProfile): void {
    sessionStorage.setItem(this.storageKey, JSON.stringify(user));
    this.userProfile.next(user);
  }

  /**
   * Returns an `Observable` that emits user profile
   * Will immidiately emit a value if profile has already been set
   * @returns `Observable` that emits `HhsgUserProfile`
   */
  getUserProfile(): Observable<HhsgSharedUserProfile> {
    return this.userProfile.asObservable();
  }
}
